import { takeLatest } from 'redux-saga/effects';
import {
  getRewardListSuccess, getRewardListFail,
  getRewardDetailsSuccess, getRewardDetailsFail,
  getAutoRewardListSuccess, getAutoRewardListFail,
  getUnAutoRewardListSuccess, getUnAutoRewardListFail,
} from './rewardState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/rewards');
const redirectData = { route:'/console/rewards', mode:'list', recordId:0 };
const modelName = 'Reward';
const modelId = 'rwd_id';

function* getRewardList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getRewardListSuccess,
    getRewardListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getRewardDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getRewardDetailsSuccess,
    getRewardDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doRewardCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getRewardDetailsSuccess,
    getRewardDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

function* doRewardUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(data.payload[modelId], data.payload),
    getRewardDetailsSuccess,
    getRewardDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    UPDATING_MSG
  );
}

function* doRewardDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getRewardDetailsSuccess,
    getRewardDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* getAutoRewardList(data) {
  yield doCrudCall(
    () => crudService.doGetRequest('automatic-rewards', data.payload),
    getAutoRewardListSuccess,
    getAutoRewardListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getUnAutoRewardList(data) {
  yield doCrudCall(
    () => crudService.doGetRequest('unautomatic-rewards', data.payload),
    getUnAutoRewardListSuccess, 
    getUnAutoRewardListFail,
    null,
    null,
    LOADING_MSG
  );
}


function* rewardSaga() {
  yield takeLatest('reward/getRewardList', getRewardList);
  yield takeLatest('reward/getRewardDetails', getRewardDetails);
  yield takeLatest('reward/doRewardCreate', doRewardCreate);
  yield takeLatest('reward/doRewardUpdate', doRewardUpdate);
  yield takeLatest('reward/doRewardDelete', doRewardDelete);
  yield takeLatest('reward/getAutoRewardList', getAutoRewardList);
  yield takeLatest('reward/getUnAutoRewardList', getUnAutoRewardList);
}

export default rewardSaga;
